import StaticPageBody from './StaticPageBody';
import StaticPageHeader from './StaticPageHeader';

interface StaticPageProps {
  title: string;
  subTitle?: React.ReactNode | string;
  children: React.ReactNode;
}

const StaticPage = ({title, subTitle, children}: StaticPageProps) => {
  return (
    <>
      <StaticPageHeader title={title} subTitle={subTitle} />
      <StaticPageBody>{children}</StaticPageBody>
    </>
  );
};

export default StaticPage;
